import(/* webpackMode: "eager", webpackExports: ["Navbar"] */ "C:\\Users\\HP\\Desktop\\rombex_web\\rombex-homepage-design-main\\components\\navbar.tsx");
;
import(/* webpackMode: "eager" */ "C:\\Users\\HP\\Desktop\\rombex_web\\rombex-homepage-design-main\\node_modules\\next\\dist\\client\\app-dir\\link.js");
;
import(/* webpackMode: "eager" */ "C:\\Users\\HP\\Desktop\\rombex_web\\rombex-homepage-design-main\\node_modules\\next\\dist\\client\\image-component.js");
